<template>
	<v-col class="background">
		<v-row>
			<v-col cols="4" class="text-center">
				<v-img contain :src="cashLogo" alt="logo" />
			</v-col>
			<v-col cols="4" class="text-center">
				<span>Winning Numbers</span>
			</v-col>
			<v-col cols="4" class="text-center">
				<v-img contain :src="cashLogo" alt="logo" />
			</v-col>
		</v-row>
		<v-row v-for="number in result.numbers" :key="number.playType.id">
			<v-col class="text-center" cols="4">
				<v-img
					contain
					height="100"
					:src="imageForPlayType(number.playType)"
					alt="playType"
				/>
			</v-col>
			<v-col cols="8">
				<v-img
					contain
					class="d-inline-block"
					height="100"
					width="110"
					v-for="(result, index) in number.digits"
					:key="index"
					:src="
						(index % 2 === 0 ? greenBalls : orangeBalls)[parseInt(result, 10)]
					"
					alt="result"
				/>
			</v-col>
		</v-row>
	</v-col>
</template>

<script>
import ResultField from '../../../../enumerations/ResultField.json';
import cashLogo from 'assets/static/img/logo/quickcash_black_and_white.png';
import ImageGreen0 from 'assets/static/img/balls/quickcash/ball_0_green.png';
import ImageGreen1 from 'assets/static/img/balls/quickcash/ball_1_green.png';
import ImageGreen2 from 'assets/static/img/balls/quickcash/ball_2_green.png';
import ImageGreen3 from 'assets/static/img/balls/quickcash/ball_3_green.png';
import ImageGreen4 from 'assets/static/img/balls/quickcash/ball_4_green.png';
import ImageGreen5 from 'assets/static/img/balls/quickcash/ball_5_green.png';
import ImageGreen6 from 'assets/static/img/balls/quickcash/ball_6_green.png';
import ImageGreen7 from 'assets/static/img/balls/quickcash/ball_7_green.png';
import ImageGreen8 from 'assets/static/img/balls/quickcash/ball_8_green.png';
import ImageGreen9 from 'assets/static/img/balls/quickcash/ball_9_green.png';
import ImageOrange0 from 'assets/static/img/balls/quickcash/ball_0_orange.png';
import ImageOrange1 from 'assets/static/img/balls/quickcash/ball_1_orange.png';
import ImageOrange2 from 'assets/static/img/balls/quickcash/ball_2_orange.png';
import ImageOrange3 from 'assets/static/img/balls/quickcash/ball_3_orange.png';
import ImageOrange4 from 'assets/static/img/balls/quickcash/ball_4_orange.png';
import ImageOrange5 from 'assets/static/img/balls/quickcash/ball_5_orange.png';
import ImageOrange6 from 'assets/static/img/balls/quickcash/ball_6_orange.png';
import ImageOrange7 from 'assets/static/img/balls/quickcash/ball_7_orange.png';
import ImageOrange8 from 'assets/static/img/balls/quickcash/ball_8_orange.png';
import ImageOrange9 from 'assets/static/img/balls/quickcash/ball_9_orange.png';
import pick2 from 'assets/static/img/picks/quickcash/pick2.png';
import pick3 from 'assets/static/img/picks/quickcash/pick3.png';
import pick4 from 'assets/static/img/picks/quickcash/pick4.png';
import pick5 from 'assets/static/img/picks/quickcash/pick5.png';

export default {
	name: 'WinningNumbers',
	props: {
		result: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			cashLogo: cashLogo,
			greenBalls: [
				ImageGreen0,
				ImageGreen1,
				ImageGreen2,
				ImageGreen3,
				ImageGreen4,
				ImageGreen5,
				ImageGreen6,
				ImageGreen7,
				ImageGreen8,
				ImageGreen9
			],
			orangeBalls: [
				ImageOrange0,
				ImageOrange1,
				ImageOrange2,
				ImageOrange3,
				ImageOrange4,
				ImageOrange5,
				ImageOrange6,
				ImageOrange7,
				ImageOrange8,
				ImageOrange9
			]
		};
	},
	mounted() {
		this.$confetti.start();
	},
	destroyed() {
		this.$confetti.stop();
	},
	methods: {
		imageForPlayType(playType) {
			switch (playType.id) {
				case ResultField.PickTwo:
					return pick2;
				case ResultField.CashThree:
					return pick3;
				case ResultField.PickFour:
					return pick4;
				case ResultField.PickFive:
					return pick5;
			}
		}
	}
};
</script>
